import React, { Component } from "react";
import Utility from "../../../../common/utility";
import Collapsible from "react-collapsible";
import { iosHomeOutline } from "react-icons-kit/ionicons/iosHomeOutline";
import { calendar } from "react-icons-kit/ionicons/calendar";
import { Icon } from "react-icons-kit";
import { connectionBars } from "react-icons-kit/ionicons/connectionBars";
import { iosAlbumsOutline } from "react-icons-kit/ionicons/iosAlbumsOutline";
import { office } from "react-icons-kit/icomoon/office";
import { angleDoubleDown } from "react-icons-kit/fa/angleDoubleDown";
import { inject, observer } from "mobx-react";
import "../../../../assets/css/components/Profile/EnvironmentSelection/License/LicenseComponent.css";
import ApiCalls from "../../../apis/api-calls";
import { ic_content_copy } from "react-icons-kit/md/ic_content_copy";
import successIcon from "../../../../assets/images/copytxt.png";
import { infoCircle } from "react-icons-kit/fa/infoCircle";
import { ic_arrow_drop_down } from "react-icons-kit/md/ic_arrow_drop_down";

const LicenseTab = inject("sharedStore", "profileStore")(
  observer(
    class LicenseComponent extends Component {
      constructor(props) {
        super(props);
        this.state = {
          licenseData: [],
          modules: [],
          subClientData: []
        };
      }

      fetchSubClientInfo(companyId) {
        const { subClientData } = this.state;
        if (subClientData.length > 0) {
          return subClientData.filter(e => e.id === companyId).length > 0
            ? null
            : subClientData.map((data, i) => {
                this.props.sharedStore.showLoader();
                return ApiCalls.getSubClientInfo(companyId)
                  .then(json => {
                    this.props.sharedStore.hideLoader();
                    if (json && json.error === false) {
                      subClientData.push(json.data);
                      this.setState({
                        subClientData: subClientData
                      });
                    }
                  })
                  .catch(err => {
                    this.props.sharedStore.hideLoader();
                  });
              });
        } else {
          this.props.sharedStore.showLoader();
          ApiCalls.getSubClientInfo(companyId)
            .then(json => {
              this.props.sharedStore.hideLoader();
              let arr = [];
              if (json && json.error === false) {
                arr.push(json.data);
                this.setState({
                  subClientData: arr
                });
              } else {
                this.setState({
                  subClientData: []
                });
              }
            })
            .catch(err => {
              this.props.sharedStore.hideLoader();
            });
        }
      }

      renderLicenseList() {
        let { licenseData } = this.props.sharedStore;
        // var license_status = Utility.compareDate(licenseData.end_Date  ? licenseData.end_Date : null) ? "Active" : "Expired";
        return (
          <div key={"licenseList"} className="linceses_wrapper">
            <div className="lic_contant">
              <div className="linceses_items">
                {licenseData && licenseData.client_name
                  ? licenseData.client_name
                  : ""}
              </div>
              <div className="linceses_items">
                {licenseData && licenseData.sub_client_name
                  ? licenseData.sub_client_name
                  : ""}
              </div>
              <div className="linceses_items">
                {licenseData && licenseData.license_mode
                  ? licenseData.license_mode
                  : ""}
              </div>
              <div className="linceses_items">
                {licenseData && licenseData.license_status
                  ? licenseData.license_status
                  : ""}
              </div>
              <div className="linceses_items">
                {licenseData && licenseData.end_Date
                  ? Utility.getDate(licenseData.end_Date)
                  : null}
              </div>
            </div>
            <Collapsible
              trigger={
                <Icon className="arrowDown" size={20} icon={angleDoubleDown} />
              }
            >
              {this.renderExpandCollapse(licenseData)}
            </Collapsible>
          </div>
        );
      }

      renderSubClientList = () => {
        let { licenseData } = this.props.sharedStore;
        return (
          licenseData &&
          licenseData.subCompanies &&
          licenseData.subCompanies.map((license, i) => {
            // var license_status = utility.compareDate(license.tokenSettingEndDate  ? license.tokenSettingEndDate : null) ? "Active" : "Expired";
            let index = this.state.subClientData.findIndex(
              x => x.id === license.companyId
            );
            return (
              <div key={i} className="linceses_wrapper">
                <div className="lic_contant">
                  <div className="linceses_items">
                    {licenseData.client_name}
                  </div>
                  <div className="linceses_items">{license.companyName}</div>
                  <div className="linceses_items">
                    {license.onlineMode ? "Online" : "Offline"}
                  </div>
                  <div className="linceses_items">
                    {license.enable ? "Active" : "Expired"}
                  </div>
                  <div className="linceses_items">
                    {" "}
                    {license.tokenSettingEndDate
                      ? Utility.getDate(license.tokenSettingEndDate)
                      : null}
                  </div>
                </div>

                <Collapsible
                  lazyRender={true}
                  onOpen={() => this.props.sharedStore.hideLoader()}
                  onOpening={() => this.fetchSubClientInfo(license.companyId)}
                  trigger={
                    <Icon
                      className="arrowDown"
                      size={20}
                      icon={angleDoubleDown}
                    />
                  }
                >
                  {index > -1
                    ? this.renderExpandCollapse(this.state.subClientData[index])
                    : "Loading..."}
                </Collapsible>
              </div>
            );
          })
        );
      };

      copyTxt = e => {
        let elem = e.target;
        for (; elem && elem !== document; elem = elem.parentNode) {
          if (elem.className === "subContainer") {
            let keyvalue = elem.querySelector("input");
            let copytxt = elem.querySelector(".cpyTxt");
            keyvalue.select();
            document.execCommand("copy");
            copytxt.style.visibility = "visible";
            setTimeout(function() {
              copytxt.style.visibility = "hidden";
            }, 3000);
          }
        }
        return null;
      };
      renderExpandCollapse(licenseData) {
        return (
          <div className="list-group">
            <div className="topHalf">
              <div
                className="moduleHeader"
                style={{ fontFamily: "sans-serif", fontWeight: "bold" }}
              >
                Module
              </div>
              <div className="moduleContainer">
                {licenseData &&
                  licenseData.modules &&
                  licenseData.modules.map((mod, i) => {
                    return (
                      <div key={i}>
                        <label className="containerLabel">
                          {mod.name}
                          <input
                            type="checkbox"
                            disabled
                            checked={mod.selected}
                            readOnly={true}
                          />
                          <span className="checkmark" />
                        </label>
                      </div>
                    );
                  })}
              </div>
              <div style={{ display: "inline-flex", marginRight: "35px" }}>
                <div
                  className="detailsStartDate"
                  style={{
                    marginRight: "20px",
                    fontFamily: "sans-serif",
                    fontWeight: "bold"
                  }}
                >
                  Created
                </div>
                <div />
                {/* <div>{Utility.getDate(licenseData.start_Date)}</div> */}
              </div>
            </div>
            <div className="tabKeyContainer">
              <div className="subContainer">
                <span className="custom_info_text">
                  <span className="info_help_text">
                    <Icon
                      className="info_down"
                      size={45}
                      icon={ic_arrow_drop_down}
                    />
                    Use this license key for Izenda versions 3.12 and below
                  </span>
                  <Icon
                    className="info_circle_icons"
                    size={20}
                    icon={infoCircle}
                  />
                </span>
                <label
                  htmlFor="licKey"
                  style={{ fontFamily: "sans-serif", fontWeight: "bold" }}
                >
                  License Key - 128 bit
                </label>
                <input
                  type="form"
                  id="licKey"
                  style={{ fontSize: "14px" }}
                  value={
                    licenseData && licenseData.license_key
                      ? licenseData.license_key
                      : ""
                  }
                  readOnly={true}
                />
                {licenseData && licenseData.license_key ? (
                  <div
                    className="copyicons copyKey"
                    onClick={e => this.copyTxt(e)}
                  >
                    {" "}
                    <img className="keyIcon" src={successIcon} alt="Success" />
                    <div className="cpytxtKey  copyDivCSS" />
                    <span className="cpyTxt cpytxtKey">Copied!</span>
                  </div>
                ) : (
                  <div className="copyicons visibility-hidden">
                    <Icon size={35} icon={ic_content_copy} title="Copy" />
                    <span className="cpyTxt">Copied!</span>
                  </div>
                )}
              </div>
              <div className="subContainer">
                <span className="custom_info_text">
                  <span className="info_help_text">
                    <Icon
                      className="info_down"
                      size={45}
                      icon={ic_arrow_drop_down}
                    />
                    Use this license key for Izenda versions 4.0 and above
                  </span>
                  <Icon
                    className="info_circle_icons"
                    size={20}
                    icon={infoCircle}
                  />
                </span>
                <label
                  htmlFor="licKey"
                  style={{ fontFamily: "sans-serif", fontWeight: "bold" }}
                >
                  License Key - 256 bit
                </label>
                <input
                  type="form"
                  id="licKey"
                  style={{ fontSize: "14px" }}
                  value={
                    licenseData && licenseData.license_key_fips
                      ? licenseData.license_key_fips
                      : ""
                  }
                  readOnly={true}
                />
                {licenseData && licenseData.license_key ? (
                  <div
                    className="copyicons copyKey"
                    onClick={e => this.copyTxt(e)}
                  >
                    {" "}
                    <img className="keyIcon" src={successIcon} alt="Success" />
                    <div className="cpytxtKey  copyDivCSS" />
                    <span className="cpyTxt cpytxtKey">Copied!</span>
                  </div>
                ) : (
                  <div className="copyicons visibility-hidden">
                    <Icon size={35} icon={ic_content_copy} title="Copy" />
                    <span className="cpyTxt">Copied!</span>
                  </div>
                )}
              </div>
              {licenseData.license_mode === "Offline" ? (
                <div>
                  <div className="subContainer">
                    <span className="custom_info_text">
                      <span className="info_help_text">
                        <Icon
                          className="info_down"
                          size={45}
                          icon={ic_arrow_drop_down}
                        />
                        Use this token for Izenda versions 3.12 and below
                      </span>
                      <Icon
                        className="info_circle_icons"
                        size={20}
                        icon={infoCircle}
                      />
                    </span>
                    <label
                      htmlFor="tokenKey"
                      style={{ fontFamily: "sans-serif", fontWeight: "bold" }}
                    >
                      Token - 128 bit
                    </label>
                    <input
                      type="form"
                      id="tokenKey"
                      style={{ fontSize: "14px" }}
                      value={
                        licenseData && licenseData.license_mode === "Offline"
                          ? licenseData.license_token
                          : ""
                      }
                      readOnly={true}
                    />
                    {licenseData && licenseData.license_mode === "Offline" ? (
                      <div
                        className="copyicons copyToken"
                        onClick={e => this.copyTxt(e)}
                      >
                        <img
                          className="tokenIcon"
                          src={successIcon}
                          alt="Success"
                        />
                        <div className="cpytxtToken copyDivCSS" />
                        <span className="cpyTxt cpytxtToken">Copied!</span>
                      </div>
                    ) : (
                      <div className="copyicons visibility-hidden">
                        <Icon size={35} icon={ic_content_copy} title="Copy" />
                        <span className="cpyTxt">Copied!</span>
                      </div>
                    )}
                  </div>
                  <div className="subContainer">
                    <span className="custom_info_text">
                      <span className="info_help_text">
                        <Icon
                          className="info_down"
                          size={45}
                          icon={ic_arrow_drop_down}
                        />
                        Use this token for Izenda versions 4.0 and above
                      </span>
                      <Icon
                        className="info_circle_icons"
                        size={20}
                        icon={infoCircle}
                      />
                    </span>
                    <label
                      htmlFor="tokenKey"
                      style={{ fontFamily: "sans-serif", fontWeight: "bold" }}
                    >
                      Token - 256 bit
                    </label>
                    <input
                      type="form"
                      id="tokenKey"
                      style={{ fontSize: "14px" }}
                      value={
                        licenseData && licenseData.license_mode === "Offline"
                          ? licenseData.license_token_fips
                          : ""
                      }
                      readOnly={true}
                    />
                    {licenseData && licenseData.license_mode === "Offline" ? (
                      <div
                        className="copyicons copyToken"
                        onClick={e => this.copyTxt(e)}
                      >
                        <img
                          className="tokenIcon"
                          src={successIcon}
                          alt="Success"
                        />
                        <div className="cpytxtToken copyDivCSS" />
                        <span className="cpyTxt cpytxtToken">Copied!</span>
                      </div>
                    ) : (
                      <div className="copyicons visibility-hidden">
                        <Icon size={35} icon={ic_content_copy} title="Copy" />
                        <span className="cpyTxt">Copied!</span>
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        );
      }

      render() {
        return (
          <div className="table-responsive">
            <div className="build_containt linceses_mainwrapper">
              <div className="new_linc_contant">
                <div className="license_head_contant">
                  <div class="license_head_text">
                    <Icon size={20} icon={office} /> Company
                  </div>
                  <div class="license_head_text">
                    <Icon size={20} icon={iosHomeOutline} /> Sub Client Name
                  </div>
                  <div class="license_head_text">
                    <Icon size={20} icon={iosAlbumsOutline} /> License Mode
                  </div>
                  <div class="license_head_text">
                    <Icon size={20} icon={connectionBars} /> License Status
                  </div>
                  <div class="license_head_text">
                    <Icon size={20} icon={calendar} /> End Date
                  </div>
                </div>
                {this.renderLicenseList()}
                {this.renderSubClientList()}
              </div>
            </div>
          </div>
        );
      }
    }
  )
);

export default LicenseTab;



// WEBPACK FOOTER //
// ./src/components/Profile/LicenseComponent/LicenseTab/LicenseTab.jsx